import React from 'react';

import { Box, Button, Typography } from '@mui/material';
import { Link } from 'react-router';

import { appRoutes, RouterEntitiesId } from '@clearverify/constants';

import {
  usePeoPayrollProviderById,
  usePeoPayrollProviderParamId,
} from 'src/hooks/peoPayrollProvider';
import { SxProp } from 'src/types/mui';
import { buildUrl } from 'src/utils/router';

export const PeoPPLiveStatusSettings: React.FC = () => {
  const peoPayrollProviderId = usePeoPayrollProviderParamId();
  const { isPartnership } = usePeoPayrollProviderById(peoPayrollProviderId);

  const liveStatusManageLink = buildUrl(
    isPartnership
      ? appRoutes.partnerships.detail.peoPayrollProvider.liveStatus
      : appRoutes.peoPayrollProviders.detail.liveStatus,
    {
      [RouterEntitiesId.peoPayrollProvider]: peoPayrollProviderId,
    },
  );

  return (
    <Box sx={payrollSettingsStyles}>
      <Box>
        <Typography variant="subtitle1">&quot;Is Live&quot; Status</Typography>

        <Typography variant="body1" color="text.secondary" mt={1}>
          Manage Employers &quot;Live&quot; Status
        </Typography>
      </Box>

      <Button component={Link} variant="outlined" color="primary" to={liveStatusManageLink}>
        Manage
      </Button>
    </Box>
  );
};

const payrollSettingsStyles: SxProp = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  border: '1px solid rgba(0, 0, 0, 0.12)',
  borderRadius: '8px',
  padding: '20px 24px',
};
